import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { captureFirstTouch } from '../utils/attribution';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Fire-and-forget UTM attribution: records one hit per unique
// path+query per browser session when utm_source is present.
export const UtmTracker = () => {
  const location = useLocation();
  useEffect(() => {
    captureFirstTouch();
    try {
      const params = new URLSearchParams(location.search);
      const src = params.get('utm_source');
      if (!src) return;
      const key = `utm_tracked:${location.pathname}${location.search}`;
      if (sessionStorage.getItem(key)) return;
      sessionStorage.setItem(key, '1');
      axios.post(`${API}/track/visit`, {
        utm_source: src,
        utm_medium: params.get('utm_medium'),
        utm_campaign: params.get('utm_campaign'),
        path: location.pathname,
      }).catch(() => {});
    } catch { /* tracking must never break the app */ }
  }, [location]);
  return null;
};

export default UtmTracker;
